import React from 'react';

const HeaderSection: React.FC = () => {
  return (
    <header className="bg-[#f6f6f6] h-[88px] flex items-center justify-center">
      <div className="max-w-[960px] w-full px-6 flex justify-center">
        <img src="/images/Logo.webp" alt="The Wealthy Miner" className="h-[78px] w-auto" />
      </div>
    </header>
  );
};

export default HeaderSection;
